import {
  Box,
  Button,
  Flex,
  List,
  ListItem,
  useDisclosure,
} from '@chakra-ui/react'
import {
  faArrowUpArrowDown,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons'
import { ItListItem } from 'types/graphql'

import Icon from 'src/components/widgets/Icon/Icon'
import InContextModalFrame from 'src/components/widgets/Modals/InContextModalFrame/InContextModalFrame'
import { BrandColor } from 'src/types'

const JumpToSection: React.FC<{
  jump(itemId: number): unknown
  items: ItListItem[]
  brandColor: BrandColor
}> = ({ jump, items, brandColor }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const sectionItems = items.filter(
    (item) => item.type === 'text' && !!item.text.heading
  )
  const sectionClickHandler = (itemId: number) => {
    onClose()
    jump(itemId)
  }
  if (sectionItems.length < 5) return null
  return (
    <>
      <Flex
        position="fixed"
        bottom={0}
        width="100%"
        alignItems="center"
        direction="column"
        zIndex="sticky"
        left={0}
        pb={12}
        bg="linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%)"
        pointerEvents="none"
      >
        <Button
          pointerEvents="all"
          variant="elevated"
          rightIcon={
            <Icon icon={faArrowUpArrowDown} color={brandColor} ml={2}></Icon>
          }
          boxShadow="md"
          onClick={onOpen}
        >
          Jump to Section
        </Button>
      </Flex>
      <InContextModalFrame
        onClose={onClose}
        isOpen={isOpen}
        title="Jump to Section"
        maxH={500}
      >
        <List variant="underlined" as="nav" mb={2}>
          {sectionItems.map((item) => (
            <ListItem
              px={0}
              py={4}
              key={item.id}
              borderTop="1px solid"
              borderBottom="0"
              borderColor="vapor"
              onClick={() => {
                sectionClickHandler(item.id)
              }}
            >
              <Flex gap={4} alignItems="center">
                <Box flexGrow={1}>{item.text.heading}</Box>
                <Icon px="2px" icon={faChevronRight} color={brandColor} />
              </Flex>
            </ListItem>
          ))}
        </List>
      </InContextModalFrame>
    </>
  )
}

export default JumpToSection
